import store from "../redux/store";

import { DescriptiveError } from "topkat-utils";
import { logMediumError } from "./logger";

export function applicationError(msg, extraInfos = {}, options = {}) {
  const { doThrow = false, doLog = true } = options;
  const { shopId } = store.getState().shopReducer;
  const { user } = store.getState().userReducer;

  const error = new DescriptiveError(msg, {
    doNotThrow: true,
    // stack traces are by default in the browser console
    // and this one is not relevant as it does not take in
    // account source map files
    noStackTrace: true,
    shopId,
    user,
    ...extraInfos,
  });

  if (doLog) error.log();
  else error.hasBeenLogged = true;

  const cloudWatchParsedLogs = error.logs.join("\n") + "\n";
  logMediumError(cloudWatchParsedLogs);
  if (doThrow) throw error;
}
